import React, { useEffect, useState } from 'react';
import { gql, useQuery } from "@apollo/client";
import Total from './Total';
import { useAuth0 } from '@auth0/auth0-react';

const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function CierreCaja() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);
  const { user, isAuthenticated } = useAuth0();
  const [totalDelDia, setTotalDelDia] = useState(0);

  // Obtener la fecha actual en formato YYYY-MM-DD y ajustarla a GMT-5 (Colombia, por ejemplo)
  const obtenerFechaActual = () => {
    const hoy = new Date();
    hoy.setHours(hoy.getHours() - 5);  // Ajuste para compensar si las fechas se guardan en UTC
    return hoy.toISOString().split('T')[0];
  };

  // Función para calcular el total de cada pedido
  const calcularTotal = (productos) => {
    return productos.reduce((total, producto) => {
      return total + (producto.precio * producto.cantidad);
    }, 0);
  };

  useEffect(() => {
    if (data && data.getPedidos) {
      const fechaHoy = obtenerFechaActual();

      // Filtrar los pedidos del día actual
      const pedidosDelDia = data.getPedidos.filter(pedido => 
        pedido.fecha && pedido.fecha.split('T')[0] === fechaHoy
      );

      // Calcular el total de todos los pedidos del día
      const total = pedidosDelDia.reduce((suma, pedido) => {
        return suma + calcularTotal(JSON.parse(pedido.productos));
      }, 0);

      setTotalDelDia(total);
    }
  }, [data]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const pedidos = data.getPedidos;

  // Filtrar solo los pedidos del día actual
  const pedidosDelDia = pedidos.filter(pedido => 
    pedido.fecha && pedido.fecha.split('T')[0] === obtenerFechaActual()
  );

  return (
    <div>
        <div className='card card-total'>
        <h1>Total ventas: {totalDelDia}</h1>
        </div>
     

      {isAuthenticated && (
        <div>
          <h2>{user.name}</h2>
          <p>{user.email}</p>
        </div>
      )}

      <h2>Pedidos del Día</h2>
      {pedidosDelDia.length === 0 ? (
        <p>No hay pedidos para hoy.</p>
      ) : (
        pedidosDelDia.reverse().map((pedido) => (
          <div key={pedido._id} id={`pedido-${pedido._id}`}>
            <h2>Fecha: {pedido.fecha}</h2>
            <h1>Número de Pedido: {pedido.numeroPedido}</h1>
            <h2>Estado: {pedido.estado}</h2>
            <p>Nombre del Cliente: {pedido.nombreCliente}</p>
            <p>Dirección del Cliente: {pedido.direccionCliente}</p>
            <p>WhatsApp del Cliente: {pedido.whatsappCliente}</p>
            <p>Nota del Pedido: {pedido.notaPedido}</p>
            <h3>Productos:</h3>
            <ul>
              {pedido.productos &&
                JSON.parse(pedido.productos).map((producto) => (
                  <li key={producto.id}>
                    {producto.nombre} - Precio: {producto.precio} - Cantidad: {producto.cantidad}
                  </li>
                ))}
            </ul>
            <h3>Total del Pedido: {calcularTotal(JSON.parse(pedido.productos))}</h3>
          </div>
        ))
      )}

      
    </div>
  );
}

export default CierreCaja;
